module.exports = __webpack_public_path__ + "img/money-inactive-2.860b0cc7.png";